// Opens the first settings page; every settings page lives below it.
export const SETTINGS_ROOT_PATH = '/settings';
